<template>
  <section class="faq ">
    <div class="container">
      <ul class="faq-list">

        <m-content-wrapper :content-category="contentCategories"
                           category-column="slug"
                           :content-type="contentType">
          <template v-slot="{contents}">
            <li v-for="content in contents" data-aos="fade-up" data-aos-delay="100" class="aos-init aos-animate">
              <a data-toggle="collapse" class="collapsed" :href="`#faq${content.id}`" aria-expanded="false">
                <i class="bi bi-arrow-up "></i>
                <span>{{ content.title }}</span>
              </a>
              <div :id="`faq${content.id}`" class="collapse" data-parent=".faq-list">
                <div v-html="processContent(content.body)"></div>
              </div>
            </li>
          </template>
        </m-content-wrapper>

      </ul>
    </div>
  </section>
</template>

<script>
import {DefaultProps} from "../../Post/Posts/DefaultProps";
import mContentWrapper from "../../Wrappers/ContentWrapper";
import {processContent} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/ContentFunctions";

export default {
  name: "Faq1",
  methods: {processContent},
  components: {mContentWrapper},
  props: {
    ...DefaultProps,
  },

}
</script>

<style scoped>

.faq {
  padding: 60px 0;
}

.faq .faq-list {
  padding: 0;
  list-style: none;
}

.faq .faq-list li {
  background-color: #ffee5a;
  margin-bottom: 10px;
  border-radius: 10px;
  padding: 10px 40px;
}

.faq .faq-list a {
  display: block;
  position: relative;
  font-size: 16px;
  font-weight: 600;
  color: #333333;
  text-decoration: none;
}

.faq .faq-list i {
  font-size: 16px;
  position: absolute;
  left: -25px;
  top: 6px;
  transition: 1s;
}

.faq .faq-list p {
  padding-top: 5px;
  margin-bottom: 20px;
  font-size: 15px;
}

.collapsed i {
  margin: -5px 0 0 0;
}

.bi-arrow-up:before {
  font-weight: 900 !important;
}

.collapsed i.bi.bi-arrow-up {
  transform: rotate(180deg);
}
</style>